import { render } from "./CanadaDownload.vue?vue&type=template&id=1960ca8d"
import script from "./CanadaDownload.vue?vue&type=script&lang=js"
export * from "./CanadaDownload.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__